import './testInputs.less'
import Label from '../../../../../../../components/Label'
import { usePolicyParametersContext } from '../../../../context/policyParametersContext'
import { isArrayEmptyOrFalsy } from '../../../../../../../utils/common'
import { useReduxSelector } from '../../../../../../../hooks/useReduxSelector'
import { getShowLoader } from '../../../../../../../reducers/requestReducer'
import { ACTION_VALIDATE_REGEX, validateRegex } from '../../../../../../attributes/attributesSlice'
import { HighlightedInput } from '../../../../../../attributes/settings/components/create-edit-custom-attributes/detection/patternDetection/highlightedInput'
import { PatternOptions } from '../../../../types'
import { Button, Typography } from '@lightbeamai/design-system'
import React from 'react'
import { useIntl } from 'react-intl'
import { CheckCircle, XCircle } from 'phosphor-react'
import { useDispatch } from 'react-redux'

export const TestInputs = () => {
  const intl = useIntl()

  const { detection, testText, setTestText, mode } = usePolicyParametersContext()
  const { regexValues, contextWords, regexPatternTypes } = detection
  const { isView } = mode

  const validationLoader = useReduxSelector(() => getShowLoader(ACTION_VALIDATE_REGEX))
  const validationResult = useReduxSelector((state) => state.attributes.validationResult)

  const { patternMatches = {}, contextMatches = {} } = validationResult || {}
  const totalPatternMatches = Object.keys(patternMatches)?.length || 0
  const totalContextMatches = Object.keys(contextMatches)?.length || 0

  const dispatch = useDispatch()

  const regexValue =
    detection.detectionType === PatternOptions.BASIC ? regexPatternTypes || [] : regexValues

  const handleValidateRegex = () => {
    dispatch(validateRegex({ text: testText, regexValues: regexValue, contextWords }))
  }

  if (isView) return null

  return (
    <div>
      <Label
        transId="attributeManagementSettings.customAttributes.detection.testInput"
        variant="base"
      />
      <Label
        transId="attributeManagementSettings.customAttributes.detection.testInput.description"
        type="normal"
        variant="base"
        color="secondary"
      />
      <HighlightedInput value={testText} onChange={setTestText} />
      <div className="validate-button-container xs-mt-24 flex-row align-center">
        <Button
          disabled={
            testText.length === 0 || isArrayEmptyOrFalsy(regexValue) || isView || validationLoader
          }
          onClick={handleValidateRegex}
          loading={validationLoader}
          variant="secondary"
        >
          {intl.formatMessage({
            id: 'validate'
          })}
        </Button>
        {validationResult && (
          <div className="flex-row align-center xs-ml-24">
            {totalContextMatches > 0 || totalPatternMatches > 0 ? (
              <div className="flex-row align-center" style={{ color: '#406E00' }}>
                <CheckCircle size={16} className="xs-mr-4" weight="fill" color="currentColor" />
                <Typography as="span" color="custom" variant="baseMinus2">
                  {intl.formatMessage({ id: 'attributeManagementSettings.customAttributes.match' })}
                </Typography>
              </div>
            ) : (
              <div className="flex-row align-center" style={{ color: '#8A1000' }}>
                <XCircle size={16} className="xs-mr-4" weight="fill" color="currentColor" />
                <Typography as="span" color="custom" variant="baseMinus2">
                  {intl.formatMessage({
                    id: 'attributeManagementSettings.customAttributes.noMatch'
                  })}
                </Typography>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
